import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { requestGet } from '../../api/request';
import { EVENT_MORE } from '../../api/url';
import { parseDateTime, showCountOfImages, showVideoLength } from '../Partials/Helper';
import * as actions from '../../redux/actions';

const EventMore = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const [loader, setLoader] = useState(false);
  const [event, setEvent] = useState([]);

  const getData = async () => {
    setLoader(true);

    const response = await requestGet(EVENT_MORE, {
      'lang_id': currentLanguage.id,
    });

    setEvent(response.data);
    setLoader(false);
  };

  useEffect(() => {
    dispatch(actions.adjustFontSize(fontSize));
  });

  useEffect(() => {
    if (typeof dictionary !== 'undefined') {
      getData();
    }
  }, [dictionary]);

  const showDatas = () => (
    event
      .filter((d) => d.news_type_relation.length > 0)
      .map((data) => (
        <div key={data.id} className="saidbar-item">
          <a
            href={`/event/${data.news_type_relation[0].news_type.name}/${data.id}`}
            className="meetings-item__list"
            onClick={(e) => {
              e.preventDefault();
              if (data.remote_url == null) {
                navigate(
                  `/event/${data.news_type_relation[0].news_type.name}/${data.id}`,
                );
              }
              if (data.remote_url != null) {
                navigate(data.remote_url);
              }
            }}
          >
            {data.title}
          </a>

          <div className="saidbar-item__box">
            <div className="saidbar-item__date">
              <span>{parseDateTime(data.publish_date)}</span>
            </div>

            <div className="saidbar-item__right">
              {
                (data.news_flickr_image_relation
                && data.news_flickr_image_relation.filter((t) => t.type === 'original').length > 0)
                || (data.assets
                && data.assets.length > 0) ? (
                  <div className="saidbar-item__info">
                    <div className="saidbar-item__img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="15"
                        height="12"
                        viewBox="0 0 15 12"
                      >
                        <path
                          className="st0"
                          d="M4.1,5.3c0.6,0,1.1-0.5,1.1-1.1S4.7,3,4.1,3S3,3.5,3,4.1S3.5,5.3,4.1,5.3z"
                          fill="#5F5F5F"
                        />
                        <path
                          className="st0"
                          d="M6.4,7.5L5.2,6L3,9h9L8.6,4.5L6.4,7.5z"
                          fill="#5F5F5F"
                        />
                        <path
                          className="st0"
                          d="M13.5,0h-12C0.7,0,0,0.7,0,1.5v9C0,11.3,0.7,12,1.5,12h12c0.8,0,1.5-0.7,1.5-1.5v-9C15,0.7,14.3,0,13.5,0zM1.5,10.5v-9h12l0,9H1.5L1.5,10.5z"
                          fill="#5F5F5F"
                        />
                      </svg>
                    </div>
                    <div className="saidbar-item__count">
                      {showCountOfImages(data)}
                    </div>
                  </div>
                  ) : null
              }
              {
                data.assets
                && data.assets.filter((t) => t.asset_type_id === 2).length > 0 ? (
                  <div className="saidbar-item__info">
                    <div className="saidbar-item__img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="15"
                        viewBox="0 0 15 15"
                      >
                        <path
                          className="st0"
                          d="M7.5,0C3.4,0,0,3.4,0,7.5C0,11.6,3.4,15,7.5,15S15,11.6,15,7.5C15,3.4,11.6,0,7.5,0z M7.5,13.5c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6C13.5,10.8,10.8,13.5,7.5,13.5z"
                          fill="#5F5F5F"
                        />
                        <path className="st0" d="M5.2,11.3l6-3.8l-6-3.8V11.3z" fill="#5F5F5F" />
                      </svg>

                    </div>
                    <div className="saidbar-item__count">
                      {showVideoLength(data)}
                    </div>
                  </div>
                  ) : null
              }
            </div>

          </div>
        </div>
      ))
  );

  return (
    <div className="saidbar-content">
      {loader === true ? (
        <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
          <div className="spinner-border text-success" role="status">
            <span className="sr-only" />
          </div>
        </div>
      ) : null}
      {event && event.length > 0 ? (
        <>
          <div className="saidbar-content__title">
            <span>{dictionary.menus.menu_2}</span>
          </div>
          {showDatas()}
          <div className="main-tab__button">
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event/news');
              }}
              href=""
              className="button button-update"
            >
              {dictionary.all_event}
            </a>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default EventMore;
